export function computeVerdict({
  margin = 0,
  carbonKg = 0,
  goMarginPct = 35,
  reviewMarginPct = 20,
} = {}) {
  const numericMargin = Number(margin || 0);
  const numericCarbonKg = Number(carbonKg || 0);
  let verdict = 'NO GO';

  if (numericMargin >= Number(goMarginPct)) {
    verdict = 'GO';
  } else if (numericMargin >= Number(reviewMarginPct)) {
    verdict = 'REVIEW';
  }

  const co2Downgraded = numericCarbonKg > 0 && numericCarbonKg >= 500 && verdict === 'GO';
  if (co2Downgraded) verdict = 'REVIEW';

  return {
    verdict,
    co2Downgraded,
  };
}
